import axios from '@axios';

const base = '/api/v1/offsite-magic-links';

export default {
  async get(slug) {
    const { data } = await axios.get(`${base}/magic-link/${slug}`);
    return data;
  },
}
